import { useTranslation } from 'react-i18next';
import type { ILawPartProps } from './ILawPartProps';
import { lawValue } from './lawGroups';

/**
 * «Які проблеми розв'язує закон» (прототип v4 lawProbs): картки з червоною верхньою смугою — назва, причина, «→ як розв'язує» (зелене)
 * і статті (акцент); без записів — «Проблем ще не зафіксовано.».
 */
export function LawProblems({ law, onOpen }: ILawPartProps) {
  const { t } = useTranslation();
  const items = law.of('ldprob');
  return (
    <section className="law-sec law-sec--tight">
      <div className="law-sec__title">{t('recordPage.law.problems')}</div>
      {!items.length && <span className="law__muted">{t('recordPage.law.noProblems')}</span>}
      <div className="law-probs">
        {items.map((r) => (
          <button key={r.id} type="button" className="law-prob" onClick={() => onOpen('ldprob', r)}>
            <strong>{r.title}</strong>
            <span className="law-prob__cause">{lawValue(r, 'cause')}</span>
            <span className="law-prob__how">→ {lawValue(r, 'how')}</span>
            <span className="law-prob__arts">{lawValue(r, 'articles')}</span>
          </button>
        ))}
      </div>
    </section>
  );
}
